import {SOPutRelationshipAttribute} from '../../core/relationship-attribute/so-put-relationship-attribute';
import {RelationshipAttributeCore} from './relationship-attribute.core';
import {SOGetRelationshipAttribute} from '../../core/relationship-attribute/so-get-relationship-attribute';
import {FormField, SelectionOption} from 'lionheartland';
import {putRelationshipAttributeFormFieldOptions} from './put-relationship-attribute-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {RelationshipAttributePermissionCore} from '../relationship-attribute-permission/relationship-attribute-permission.core';
import {SOGetRelationshipAttributePermission} from '../../core/relationship-attribute-permission/so-get-relationship-attribute-permission';
import {RelationshipAttributePermissionRuleCore} from '../relationship-attribute-permission-rule/relationship-attribute-permission-rule.core';
import {SOGetRelationshipAttributePermissionRule} from '../../core/relationship-attribute-permission-rule/so-get-relationship-attribute-permission-rule';
import {EntityCore} from '../entity/entity.core';
import {SOGetEntity} from '../../core/entity/so-get-entity';
import {CustomLogicRequirementCore} from '../custom-logic-requirement/custom-logic-requirement.core';
import {SOGetCustomLogicRequirement} from '../../core/custom-logic-requirement/so-get-custom-logic-requirement';
import {RelationshipCore} from '../relationship/relationship.core';
import {SOGetRelationship} from '../../core/relationship/so-get-relationship';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutRelationshipAttribute extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putRelationshipAttributeFormFieldOptions);

  RequestClass = SOPutRelationshipAttribute

  constructor(
    public entityCore: RelationshipAttributeCore
  ) {
    super();
    if (putRelationshipAttributeFormFieldOptions.relationshipAttributePermissions) {
      putRelationshipAttributeFormFieldOptions.relationshipAttributePermissions.makeCore = true;
    }
    if (putRelationshipAttributeFormFieldOptions.relationshipAttributePermissionRules) {
      putRelationshipAttributeFormFieldOptions.relationshipAttributePermissionRules.makeCore = true;
    }
    if (putRelationshipAttributeFormFieldOptions.entity) {
      putRelationshipAttributeFormFieldOptions.entity.makeCore = true;
    }
    if (putRelationshipAttributeFormFieldOptions.customLogicRequirement) {
      putRelationshipAttributeFormFieldOptions.customLogicRequirement.makeCore = true;
    }
    if (putRelationshipAttributeFormFieldOptions.relationship) {
      putRelationshipAttributeFormFieldOptions.relationship.makeCore = true;
    }
    if (putRelationshipAttributeFormFieldOptions.project) {
      putRelationshipAttributeFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('multiplicity'),
      this.getFormValueFromIdentifier('editPermissions'),
      [this.getFormValueFromIdentifier('relationshipAttributePermissions', SOGetRelationshipAttributePermission)],
      [this.getFormValueFromIdentifier('relationshipAttributePermissionRules', SOGetRelationshipAttributePermissionRule)],
      this.getFormValueFromIdentifier(
        'entity',
        SOGetEntity,
      ),
      this.getFormValueFromIdentifier(
        'customLogicRequirement',
        SOGetCustomLogicRequirement,
      ),
      this.getFormValueFromIdentifier(
        'relationship',
        SOGetRelationship,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}